<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body">
                  <h2 class="title">Print Surat Puas</h2>
                  <div class="row mb-3">
                    <div class="col-12 text-center">
                      <button class="btn btn-info mr-3" style="width: 75px;" @click="printPage">Print</button>
                      <button class="btn btn-primary" style="width: 75px;" @click="$emit('closeModal')">Kembali</button>
                    </div>
                  </div>
                  <div style="border: 1px solid black">
                    
                    <!-- PRINT WO START -->
                    <div id="printMe">
                          <div class="row">
                              <div class="col-4 offset-2 text-center" style="height: 150px; display:flex; flex-direction: column; justify-content: center;">
                                  <img src="@/assets/img/logo/company_logo_bw.png" class="img"/>
                              </div>
                              <div class="col-6 pl-5" style="display:flex; flex-direction: column; justify-content: center;">
                                  <p class="companyDetails" style="margin-bottom: 5px;font-size:.65rem;">
                                  PT Auto Prima Makmur<br>
                                  Jl. Raya Srengseng 133, jakarta 11630, Indonesia<br>
                                  Telp. : 021 58 900 800, Fax. : 021 58 44 229 - 585 14 14<br>
                                  E-mail: autoprimamotor33@gmail.com<br>
                                  Web : www.autoprimamotor.com
                                  </p>
                              </div>
                          </div>
  
                          <h4 class="text-center">SURAT PUAS & KUASA PENAGIHAN</h4>
  
                          <h5 class="mt-5 ml-4 pl-2">Yang Bertanda tangan di bawah ini menyatakan bahwa kendaraan dengan data-data berikut :</h5>
  
                          <div class="row mt-5 ml-4">
                              <div class="col-3">
                                  <h5>Jenis kendaraan</h5>
                              </div>
                              <div class="col-1">
                                  <h5>:</h5>
                              </div>
                              <div class="col-8">
                                  <h5>{{data.vehicle_type}} {{data.year}}</h5>
                              </div>
                              <div class="col-3">
                                  <h5>No. Polisi</h5>
                              </div>
                              <div class="col-1">
                                  <h5>:</h5>
                              </div>
                              <div class="col-8">
                                  <h5>{{data.registration}}</h5>
                              </div>
                              <div class="col-3">
                                  <h5>No. Work Order</h5>
                              </div>
                              <div class="col-1">
                                  <h5>:</h5>
                              </div>
                              <div class="col-8">
                                  <h5>{{form_code}}</h5>
                              </div>
                              <div class="col-3">
                                  <h5>Tertanggung</h5>
                              </div>
                              <div class="col-1">
                                  <h5>:</h5>
                              </div>
                              <div class="col-8">
                                  <h5>{{data.owner}}</h5>
                              </div>
                              <div class="col-3">
                                  <h5>No. Polis</h5>
                              </div>
                              <div class="col-1">
                                  <h5>:</h5>
                              </div>
                              <div class="col-8">
                                  <h5>{{data.policy_number}}</h5>
                              </div>
                              <div class="col-3">
                                  <h5>Perbaikan Di Bengkel</h5>
                              </div>
                              <div class="col-1">
                                  <h5>:</h5>
                              </div>
                              <div class="col-8">
                                  <h5>{{data.company}}</h5>
                              </div>
                          </div>
                          
                          <h5 class="mt-5 ml-4 pl-2">Dengan ini menerangkan sebagai berikut :</h5>
                          <h5 class="mt-3 ml-5 pl-2">1. &nbsp Bahwa kendaraan telah selesai diperbaiki dan diterima dengan hasil yang sangat memuaskan.</h5>
                          <h5 class="mt-2 ml-5 pl-2">2. &nbsp Dengan ini kami memberi kuasa penuh kepada {{data.company}} untuk menerima pembayaran klaim dari {{data.insurance_company == 'Umum' ? data.owner : data.insurance_company}} atas ganti rugi biaya perbaikan kendaraan kami tersebut diatas yang dikarenakan kejadian kecelakaan.</h5>
                          <h5 class="mt-5 ml-4 pl-2">Demikian Surat Puas dan Kuasa Penagihan ini kamu buat untuk dipergunakan sebagaimana mestinya.</h5>
                          <h5 class="mt-5 ml-4 pl-2">Jakarta, {{moment().format("DD MMMM Y")}}</h5>
                          <div class="row mt-5 ml-4">
                              <div class="col-4 ">
                                  
                                  <h5>Yang Memberi Kuasa</h5>
                                  <h5>Pemilik / Tertanggung / Wakil Pemilik</h5>
  
                                  <hr style="margin-top:100px;border-top: 3px solid black;">
                              </div>
                              <div class="col-4 offset-3 text-left">
                                  
                                  <h5>Yang Menerima Kuasa</h5>
                                  <h5>{{data.company}}</h5>
  
                                  <hr style="margin-top:100px;border-top: 3px solid black;">
                              </div>
                          </div>
                    </div>
                    <!-- PRINT WO END -->
  
                  </div>
                  
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
    import Terbilang from 'terbilang-js'
    import moment from 'moment'
  
    export default {
      data () {
        return {
          moment: moment,
          data : null
        }
      },
      props : ['form_code'],
      components:{
        MultiSelect,
      },
      async mounted () {
          this.loadData()
      },
      watch : {
      },
      methods : {
          printPage(){
        this.$htmlToPaper('printMe');
  
        
          },
          loadData () {
              this.$http.get('/api/v1/workorder-estimation/payment-statement/' + this.form_code)
              .then((resp) => {
                  this.data = resp.data.data
                  console.log(this.data)
              })
              .catch((err) => {
                  console.log(err)
              })
          }
      }
    }
  </script>
  
  <style scoped>
  
  
  
  td {
    font-size: 12px;
  }
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  
  
  .companyDetails{
    margin-bottom: 5px;
    font-size:.6rem;
  }
  /* .documentTitle{
    font-size: 40px;
    border: 1px solid black;
    border-radius: 10px;
    padding:20px 30px;
  } */
  .contentTitle{
    margin-top:8px;
    font-size:14px;
    font-weight: 700;
  }
  .contentVariable{
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
  }
  
  </style>